<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<div mat-dialog-content>
  <p>{{ data.message | translate }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ 'BUTTON.OK' | translate }}</button>
</div>
